import styled from 'styled-components';
import articles from '../articles';

const ArticleCtn = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 20px;
  background-color: var(--card-background);
  border-radius: 15px;
  margin-top: 105px;
  margin-left: 15px;
  margin-right: 15px;
  padding: 20px;
  font-weight: 300;
  font-family: Montserata, sans-serif;
  
  a:hover{
    color: var(--card-text-white);
    text-decoration: underline;
  }
  
  .article-head{
    font-family: inherit;
    font-size: 1.1rem;
    font-weight: bold;
    color: rgba(240,248,255,0.96);
    max-height: 20px;
  }
  .article-description{
    font-weight: 400;
    font-size: 0.9rem;
  }
  
  @media (min-width: 768px){
    width: 250px;
    height: 400px;

    .article-date{
      position: absolute;
      bottom: 10px;
    }
  }
`;

const ArticlesCtn = styled.div`
  display: inherit;
  flex-direction: row;
  flex-wrap: wrap;
  @media (min-width: 768px){
    display: flex;
  }
`;

function Article() {
  return (
    <ArticlesCtn>
      {articles.map((article) => (
        <ArticleCtn key={article.id}>
          <a href={article.link} target="_blank" rel="noopener noreferrer">
            <p className="article-head">
              [
              {article.language}
              ] :
              {' '}
              {article.title}
            </p>
          </a>
          <div className="article-description">{article.description}</div>
          <div className="article-date">{article.date}</div>
        </ArticleCtn>
      ))}
    </ArticlesCtn>
  );
}

export default Article;
